import React from "react";
import { Container, Row, Col } from "reactstrap"
import ClipLoader from 'react-spinners/ClipLoader'


const LoadingButton = ({ isLoading, placeholder, newSize, color, btnTextColor }) => {

  if(isLoading) {
    return (
      <React.Fragment>
        <ClipLoader  sizeUnit={ "px" } size={ !!newSize ? newSize : 24 } color={ color ? color : "#fff" }  />
      </React.Fragment>
    ) // END return

  } else {
    return (
      <React.Fragment>
        <span style={{color: btnTextColor ? btnTextColor : 'white'}}>{placeholder}</span>
      </React.Fragment>
    ) // END return

  } // END else

} // END LoadingButton


export default LoadingButton;



// WEBPACK FOOTER //
// ./src/components/LoadingButton.js